import { PropsWithChildren, useEffect } from 'react'
import { QueryClient } from '@tanstack/react-query'
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister'
import { AREAS_QUERY_KEY, fetchAreas } from 'api/areas'
import { fetchSetting, SETTINGS_QUERY_KEY } from 'api/settings'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 1000 * 60 * 60 * 24, // 24 hours
    },
  },
})

const persister = createSyncStoragePersister({
  storage: window.localStorage,
  deserialize: JSON.parse,
  serialize: JSON.stringify,
})

export const QueryProvider = ({ children }: PropsWithChildren) => {
  useEffect(() => {
    queryClient
      .prefetchQuery({
        queryKey: [AREAS_QUERY_KEY],
        queryFn: fetchAreas,
      })
      .catch(console.error)
    queryClient
      .prefetchQuery({
        queryKey: [SETTINGS_QUERY_KEY],
        queryFn: fetchSetting,
      })
      .catch(console.error)
  }, [])

  return (
    <PersistQueryClientProvider client={queryClient} persistOptions={{ persister }}>
      {children}
    </PersistQueryClientProvider>
  )
}
